
<template>
	<Overlay
		title="Ik weiger de gebruiksvoorwaarden."
		ref="overlay"
		class="overlay--gdprTermsDenied"
		:root="true"
		:isShown="false"
		@beforehide="onBeforeHide"
	>
		<template #body>
			<slot name="body">
				<p>Ben je zeker dat je de gebruiksvoorwaarden wil weigeren? Als je weigert, word je afgemeld en naar het inlogscherm van Mijn Mooie Straat verwezen.</p>
			</slot>
		</template>
		<template #footer>
			<div class="overlay-footerContent">
				<div class="footer-actions-group">
					<button
						class="button button--light button--shakespeare button--hasIconBefore button--hasArrowLeftIcon"
						@click="onBackToTerms"
					>
						Terug naar de gebruiksvoorwaarden.
					</button>
					<button
						class="button button button--filled button--big"
						@click="onLogoutClick"
					>
						{{ buttonText }}
					</button>
				</div>
			</div>

		</template>
	</Overlay>


</template>

<script src="./GdprTermsDeniedOverlay.js"></script>
